import * as React from 'react';
import { useSelector } from 'react-redux';
import { MESSAGE_TYPES } from '../../../../src/shared/constants';
import { getChatMessages } from '../../selectors/messages';
import { ClientMessage } from './client-message';
import { OperatorMessage } from './operator-message';
import { OperatorTypingIndicator } from './operator-typing-indicator';
import { SystemMessage } from './system-message';
import './chat-messages.css';

// TODO add types
const ChatMessages = () => {
  const messages = useSelector(getChatMessages);

  return (
    <React.Fragment>
      {messages.map((msg) => {
        const { message, messageType, timestamp, operator, translated_message, intlKey, intlValues, type, fe_ts } = msg;
        const key = `${message}-fe_ts-${fe_ts}-ts-${timestamp}`;

        switch (messageType) {
          case  MESSAGE_TYPES.FROM_USER:
            return (
              <ClientMessage
                key={key}
                className="sg-message-vertical-align-client"
                timestamp={fe_ts || timestamp}
                message={message}
                messageStatus={msg.messageStatus}
              />
            );
          case  MESSAGE_TYPES.FROM_OPERATOR:
            return (
              <OperatorMessage
                key={key}
                className="sg-message-vertical-align-operator"
                timestamp={timestamp}
                operator={operator}
                message={message}
                translatedMessage={translated_message}
              />
            );
          default:
            return (
              <SystemMessage
                key={key}
                className="sg-message-vertical-align-system"
                message={message}
                intlKey={intlKey}
                intlValues={intlValues}
                type={type}
              />
            );
        }
      })}

      <OperatorTypingIndicator />
    </React.Fragment>
  );
};

export default ChatMessages;
